import { Avatar, Badge, Tooltip } from 'flowbite-react';
import { HiTrash } from 'react-icons/hi2';

export interface UserLike {
    userId: string,
    userName: string,
    picture?: string | null | undefined
    company?: string
    companyLogo?: string
    room?: string
}

interface UserAvatarProps {
    user: UserLike
    showCompany?: boolean
    showRoom?: boolean
    onDelete?: (user: UserLike) => void
}

export default function UserAvatar({user, showRoom, showCompany, onDelete}: UserAvatarProps) {
    return (
        <Tooltip content={<UserTooltip user={user} showRoom={showRoom} showCompany={showCompany}/>}>
            <Avatar img={user.picture ?? undefined} rounded alt={user.userName} className={"relative"}>
                {
                    onDelete ?
                        (
                            <Badge
                                className={"absolute -top-2 end-2"}
                                onClick={() => onDelete(user)}
                                color={"failure"}
                                icon={HiTrash}
                                size={"sm"}
                            />
                        ) : null
                }
            </Avatar>
        </Tooltip>
    )
}


function UserTooltip({user, showRoom, showCompany}: UserAvatarProps) {
    return (
        <div>
            <span>{user.userName}</span>
            {
                showCompany && user.companyLogo && user.company?
                    <img src={user.companyLogo} alt={user.company} className={"h-8"}/> : null
            }
            {
                showRoom && user.room ?
                    <span>{user.room}</span> : null
            }
        </div>
    )
}